export let musiclist =  {
  "1": {
    "ID": "1",
    "Titel": "No Drama",
    "Titel2": "",
    "Artist": "High15",
    "Land": "",
    "LandSwe": "",
    "Year": "2019",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp party",
    "Kategori2": "",
    "uri": "spotify:track:7BmOjtb7S6XzIJUJL5l7FR",
    "preview_url": "https://p.scdn.co/mp3-preview/cddcad45c659f60455397ae4244ac0f2328f2040"
  },
  "2": {
    "ID": "2",
    "Titel": "Sean den förste Banan",
    "Titel2": "",
    "Artist": "Sean Banan",
    "Land": "",
    "LandSwe": "",
    "Year": "2012",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp party",
    "Kategori2": "",
    "uri": "spotify:track:5J2UfqBylH8jDQZJnxby81",
    "preview_url": "https://p.scdn.co/mp3-preview/7072b216ae1f8bafbba92fa456427af0a2d367c7"
  },
  "3": {
    "ID": "3",
    "Titel": "Upp o hoppa (feat. Headline)",
    "Titel2": "",
    "Artist": "Frida, Headline",
    "Land": "",
    "LandSwe": "",
    "Year": "2008",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp party",
    "Kategori2": "",
    "uri": "spotify:track:6JxtniBLCc0R8fqEjqztzC",
    "preview_url": "https://p.scdn.co/mp3-preview/555d74afb234cbcc76bfe5f086908a7b71a7d0d5"
  },
  "4": {
    "ID": "4",
    "Titel": "Refrain Refrain",
    "Titel2": "",
    "Artist": "Pay TV",
    "Land": "",
    "LandSwe": "",
    "Year": "2005",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp party",
    "Kategori2": "",
    "uri": "spotify:track:0gclXLC7bYOURYeda3ILaj",
    "preview_url": "https://p.scdn.co/mp3-preview/7a4b6fc6e26255101716be2fbae5f221a71cfc87"
  },
  "5": {
    "ID": "5",
    "Titel": "Rik",
    "Titel2": "",
    "Artist": "Albin Johnsén, Mattias Andréasson",
    "Land": "",
    "LandSwe": "",
    "Year": "2016",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp party",
    "Kategori2": "",
    "uri": "spotify:track:07CSwwllAOzI08fwQqipKX",
    "preview_url": "https://p.scdn.co/mp3-preview/ad8281f363246966ce380325f939a4a1addc96cf"
  },
  "6": {
    "ID": "6",
    "Titel": "Hösten är vår",
    "Titel2": "",
    "Artist": "Britt-Inger Dreilick",
    "Land": "",
    "LandSwe": "",
    "Year": "1959",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp relaxed",
    "Kategori2": "",
    "externalId": "",
    "preview_url": ""
  },
  "7": {
    "ID": "7",
    "Titel": "En gång i Stockholm",
    "Titel2": "",
    "Artist": "Monica Zetterlund, Carli Tornehave",
    "Land": "",
    "LandSwe": "",
    "Year": "1963",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp relaxed",
    "Kategori2": "",
    "uri": "spotify:track:07hcAtqiaRRc94E0JqRr9x",
    "preview_url": "https://p.scdn.co/mp3-preview/b81f8b5a64d09ff0524c3144175438cfba7c32ac"
  },
  "8": {
    "ID": "8",
    "Titel": "Någon saknar dig",
    "Titel2": "",
    "Artist": "Östen Warnerbring",
    "Land": "",
    "LandSwe": "",
    "Year": "1959",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp relaxed",
    "Kategori2": "",
    "uri": "spotify:track:3PQBLllLUTENHOpWeOdVRy",
    "preview_url": "https://p.scdn.co/mp3-preview/c269a9d8089b4a073c29a1740e78f9ed79040ca8"
  },
  "9": {
    "ID": "9",
    "Titel": "Mitt guld",
    "Titel2": "",
    "Artist": "Pernilla Andersson",
    "Land": "",
    "LandSwe": "",
    "Year": "2016",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp relaxed",
    "Kategori2": "",
    "uri": "spotify:track:0dZJzpoEcvLBLACmZQVL5I",
    "preview_url": "https://p.scdn.co/mp3-preview/383f11ad432f7a31dbd9b8382363bbcf7cd0e90f"
  },
  "10": {
    "ID": "10",
    "Titel": "Lyckans soluppgång",
    "Titel2": "",
    "Artist": "Ulla Christenson",
    "Land": "",
    "LandSwe": "",
    "Year": "1959",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Topp relaxed",
    "Kategori2": "",
    "externalId": "",
    "preview_url": ""
  },
    "11": {
    "ID": "11",
    "Titel": "Somebody wants",
    "Titel2": "",
    "Artist": "The Lovers of Valdaro",
    "Land": "",
    "LandSwe": "",
    "Year": "2019",
    "Sprak": "",
    "Placering": "",
    "Kategori": "Upprepning",
    "Kategori2": "",
    "externalId": "",
    "uri": "spotify:track:4yBhzlf4bm26gnNVOARz2e",
    "preview_url": "https://p.scdn.co/mp3-preview/42489b0b22fcc499f231f424bed7f1c0eb2a0b08"
  }
};
